export default __webpack_public_path__ + "static/media/menu.04fb88e8.svg";